// PROD-DEMO-LOCKDOWN-1 (Feb 2026) — Public lockdown banner.
//
// Renders a discreet amber banner on public pages when the backend
// `DEMO_LOCKDOWN_BANNER_ENABLED` flag is on. Zero PII · zero IDs · no
// runtime errors leaked.

import React from "react";
import { useRuntimeConfig } from "../hooks/useRuntimeConfig";
import { useLang } from "../i18n";

export function DemoLockdownBanner() {
  const { t } = useLang();
  const cfg = useRuntimeConfig();
  if (!cfg.demo_lockdown_banner_enabled) return null;
  return (
    <div
      data-testid="demo-lockdown-banner"
      className="w-full border-b border-amber-300 bg-amber-50 text-amber-900 px-4 py-2 text-sm flex items-center gap-3"
    >
      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-200 text-amber-900 font-bold">
        ⓘ
      </span>
      <div className="flex-1">
        <span className="font-semibold mr-2" data-testid="demo-lockdown-banner-title">
          {t("demoLockdown.bannerTitle")}
        </span>
        <span data-testid="demo-lockdown-banner-body">
          {t("demoLockdown.bannerBody")}
        </span>
      </div>
    </div>
  );
}
